(ns ui.view.nev.model
  (:require
   [common.schema.entity-types :as entity-types]
   [ui.view.card.model :as card-model]))

(defn cannot-configure-view-for-entity-type?
  [entity-type]
  (entity-types/counterparty-diligence-entity-type? entity-type))

;; Malli Schemas
(def EntityID [:or :int :string])

;; TODO: Make this up to date
(def StateSchema
  [:map
   [:view-id EntityID]
   [:entity-id EntityID]
   [:card-state [:map-of EntityID card-model/CardStateSchema]]
   [:error? {:optional true} :boolean]])

(def initialized-path [:initialized?])

(defn initialized-full-path
  [state-path]
  (into state-path initialized-path))

(def card-remount-counter-path [:card-remount-counter])

(defn card-remount-counter-full-path
  [state-path]
  (into state-path card-remount-counter-path))

(def view-id-path [:view-id])

(defn view-id-full-path [state-path]
  (into state-path view-id-path))

(def primary-entity-id-path [:primary-entity-id])

(defn primary-entity-id-full-path
  [state-path]
  (into state-path primary-entity-id-path))

(def primary-entity-type-path [:primary-entity-type])

(defn primary-entity-type-full-path
  [state-path]
  (into state-path primary-entity-type-path))

(def entities-path [:entities])

(defn entities-full-path [state-path]
  (into state-path entities-path))

(def card-states-path [:card-states])

(defn card-states-full-path [state-path]
  (into state-path card-states-path))

(def selected-top-level-section-path [:selected-top-level-section])

(defn selected-top-level-section-full-path
  [state-path]
  (into state-path selected-top-level-section-path))

(def selected-section-path [:selected-section])

(defn selected-section-full-path [state-path]
  (into state-path selected-section-path))

(defn card-state-full-path
  [state-path viewed-entity-id card-id]
  (into (card-states-full-path state-path) [viewed-entity-id card-id]))

(def sidebar-mode-path [:sidebar-mode])

(defn sidebar-mode-full-path
  [state-path]
  (into state-path sidebar-mode-path))

(def selected-entity-id-path [:selected-entity-id])

(defn selected-entity-id-full-path
  [state-path]
  (into state-path selected-entity-id-path))

(def selected-entity-type-path [:selected-entity-type])

(defn selected-entity-type-full-path
  [state-path]
  (into state-path selected-entity-type-path))

(defn get-entities [db state-path]
  (get-in db (entities-full-path state-path)))

(defn get-entity [db state-path entity-id]
  (let [entities (get-entities db state-path)]
    (get entities entity-id)))

(defn merge-entities [db state-path entities-by-id]
  (update-in db (entities-full-path state-path) merge entities-by-id))

(defn collapse-sidebar-if-not-pinned
  [db state-path]
  (let [path (sidebar-mode-full-path state-path)
        sidebar-mode (get-in db path)]
    (if (not= sidebar-mode :pinned)
      (assoc-in db path :collapsed)
      db)))
